export default __webpack_public_path__ + "static/media/LikeIcon-primary.0d71dde2.svg";